
import WDForm from '../gui/form/wd-form';
import WDButton from '../gui/button/wd-button';
import WDPasswordRequest from './wd-password-request';

export default class WDUserPass extends WDForm {

  #enterBtn = null;
  #body = null;
  #buttons = null;
  
  constructor(opts)
  {
    super({wrapper_class:'col-12'}).classList.add('wd-userpass-form');

    this.addForms([ 
      {name:'login', type:'text', autocapitalize:'none', autocomplete:'username', placeholder:'Login', onkeyup:() => this.handleKeyUp() },
      {name:'password', type:'password', autocomplete:'current-password', placeholder:'Password', onkeyup:() => this.handleKeyUp() }
    ]);

    this.#body = wdc('<div class="wd-login-body"/>');
    this.append(this.#body);

    this.#buttons = wdc('<div class="wd-login-buttons"/>');
    this.append(this.#buttons);
    
    let btnCol = 'col-12';
    
    if (WDConfig?.passwordReset?.enable == true)
    {
      btnCol = 'col-6';
      
      const resetBtn = new WDButton({label:'Forgot Your Password?',click:() => this.resetPassword()});
      resetBtn.classList.add('reset-password');
      this.#buttons.append(resetBtn);
    }

    this.#enterBtn = new WDButton({label:'Login',fasIcon:'sign-in-alt',theme:'success'});
    this.#enterBtn.classList.add('wd-userpass-submit');
    this.#enterBtn.on('click',(evt) => this.handleSubmit() );
    this.#buttons.append(this.#enterBtn);
    
    return this;
  };

  //accessor
  get body() { return this.#body; };
  get enterBtn() { return this.#enterBtn; };
  
  //
  handleKeyUp(evt)
  {
   if (!evt) evt = window.event;

    if (evt.which == "13")
    {
      const formData = this.value;
      
      if (formData.login.length > 0 && formData.password.length > 0)
      {
        this.handleSubmit();
        return false;
      }
    }
  };

  handleSubmit()
  {
    //chrome doesn't fire onchange when a user autocompletes the password,
    //so our form model is never updated
    this.trigger('form:submitted',{
      login: this.getItem('login').value,
      password: this.getItem('password').value 
    });
  };

  clearForm()
  {
    this.getItem('login').value = '';
    this.getItem('password').value = '';
    this.#body.replaceChildren();
  };

  resetPassword()
  {
    const m = new WDPasswordRequest();
    m.show();
  };

};

customElements.define('wd-user-pass',WDUserPass);
